import { SVGProps } from "react";

const PencilNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.0475 2.99806L4.20585 10.2397C3.94752 10.5147 3.69752 11.0564 3.64752 11.4314L3.33918 14.1314C3.23085 15.1064 3.93085 15.7731 4.89752 15.6064L7.58085 15.1481C7.95585 15.0814 8.48085 14.8064 8.73918 14.5231L15.5809 7.2814C16.7642 6.0314 17.2975 4.6064 15.4558 2.86473C13.6225 1.13973 12.2308 1.74806 11.0475 2.99806Z"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.90625 4.20898C10.2646 6.50898 12.1312 8.26732 14.4479 8.50065"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 18.332H17.5"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default PencilNew;
